import { graphql } from 'react-relay';

export const fundsSelectionFragment = graphql`
    fragment FundsSelection_component on FundsSelection {
        title
        fundstable {
            ...FundsTable_table
        }
        downloadOverview {
            ...FundsListDownload_fundsListDownload
        }
    }
`;
